export enum Colors {
  BackgroundDefault = 'rgba(255, 255, 255, 1)',
  BackgroundDefaultDisabled = 'rgba(223, 223, 223, 1)',
  BackgroundDefaultHover = 'rgba(21, 21, 21, 0.1)',
  BackgroundDefaultSelected = 'rgba(255, 240, 239, 1)',
  BackgroundSecondary = 'rgba(20, 22, 25, 1)',
  Primary = 'rgba(219, 60, 0, 1)',
  PrimaryHover = 'rgba(149, 48, 0, 1)',
  PrimaryTransparent = 'rgba(219, 60, 0, 0.5)',
  TextDefault = 'rgba(21, 21, 21, 1)',
  TextDefaultDisabled = 'rgba(140, 140, 140, 1)',
  TextSecondary = 'rgba(255, 255, 255, 1)',
}
